import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  Container,
  MainText,
  Description,
  ButtonWrapper,
  RejectButton,
  AcceptButton,
  RejectButtonWrapper,
  AcceptButtonWrapper,
  LabelContainer,
  Bottom,
} from './BonusModal.style';
import { getFormattedNumber } from "@utils";
import { localStorage } from "@utils";
import {
  ENGLISH_LANGUAGE_CODE_LK,
  BURMESE_LANGUAGE_CODE_LK,
} from "@constants";
import {
  BonusModalBgMM,
  BonusModalBgEng,
  BonusModalBgCh,
  PromoBonusModalCH,
  PromoBonusModalEN,
  PromoBonusModalMM,
} from '@assets'

const BonusModal = ({
  amount,
  bonus_percent,
  open,
  handleClose,
  onBonusAccept,
  isPromoUser,
  exceed_bonus_limit,
  total_amount,
  max_topup_reward,
}) => {
  const { t } = useTranslation();
  const userPreferedLanguage = localStorage.getUserPreferedLanguage();

  const calculateBonus = () => {
    return exceed_bonus_limit ? max_topup_reward : Math.ceil(amount * bonus_percent * 0.01);
  }

  const calculateTotal = () => {
    return exceed_bonus_limit ? total_amount : (amount + calculateBonus());
  }

  const getBonusModalBg = () => {
    switch (userPreferedLanguage) {
      case ENGLISH_LANGUAGE_CODE_LK:
        return isPromoUser ? PromoBonusModalEN : BonusModalBgEng;
      case BURMESE_LANGUAGE_CODE_LK:
        return isPromoUser ? PromoBonusModalMM : BonusModalBgMM;
      default:
        return isPromoUser ? PromoBonusModalCH : BonusModalBgCh;
    }
  };

  return (
    <Modal
      centered
      closable={false}
      open={open}
      footer={false}
      width={400}
      bg={getBonusModalBg()}
    >
      <Container >
        <LabelContainer>
          <MainText style={{ zIndex: 100 }}>
            {t("wallet.firstTopupBonusMessage", {
              bonus_percent,
              amount: getFormattedNumber(amount),
              bonus_amount: getFormattedNumber(calculateBonus()),
              total: getFormattedNumber(calculateTotal()),
            })}
            <div>
              {exceed_bonus_limit && t("wallet.maxBonusAmount", { max_topup_reward: getFormattedNumber(max_topup_reward) })}
            </div>
          </MainText>
        </LabelContainer>

        <Bottom >
          <Description> {t("wallet.bonusAgreeStatement")} </Description>

          <ButtonWrapper>
            <RejectButtonWrapper>
              <RejectButton onClick={handleClose} > {t("wallet.reject")} </RejectButton>
            </RejectButtonWrapper>

            <AcceptButtonWrapper>
              <AcceptButton onClick={onBonusAccept} > {t("wallet.accept")} </AcceptButton>
            </AcceptButtonWrapper>

          </ButtonWrapper>
        </Bottom>

      </Container>
    </Modal>
  )
}

export default BonusModal;